/// <amd-module name="Dashboards/Directory/redux/DashboardsDirectoryArtifactReducer" />
import produce from "immer";
import { DashboardWithOwner, IDashboardsDirectoryArtifactState } from "../DashboardsDirectoryContracts";
import { DashboardsDirectoryActions, DashboardsDirectoryActionTypes } from "./DashboardsDirectoryActions";

/**
 * Reducer which handles actions related to the directory artifacts
 */
export function artifactReducer(state: IDashboardsDirectoryArtifactState, action: DashboardsDirectoryActions): IDashboardsDirectoryArtifactState {
    state = state || getDefaultState();

    return produce(state, draft => {
        switch (action.type) {
            case DashboardsDirectoryActionTypes.MyDashboardsLoaded: {
                draft.myDashboards = action.payload;
                break;
            }

            case DashboardsDirectoryActionTypes.MyOwnersLoaded: {
                draft.myOwners = action.payload;
                break;
            }

            case DashboardsDirectoryActionTypes.MyFavoritesLoaded: {
                draft.favorites = action.payload;
                break;
            }

            case DashboardsDirectoryActionTypes.MruDashboardLoaded: {
                draft.mruDashboard = action.payload;
                break;
            }

            case DashboardsDirectoryActionTypes.AllDashboardsAndTeamsLoaded: {
                draft.allDashboards = action.payload.dashboards;
                draft.allOwners = action.payload.owners;
                break;
            }

            case DashboardsDirectoryActionTypes.SetCanPerformDashboardActionsPermission: {
                draft.canCreateDashboardsPermission = action.payload.addPermission;
                draft.canManageDashboardsSecurityPermission = action.payload.manageSecurityPermission;
                draft.canDeleteDashboardsPermission = action.payload.deletePermission;
                break;
            }

            case DashboardsDirectoryActionTypes.SetCanUseTeamPanelPermission: {
                draft.canUseTeamPanelPermission = action.payload;
                break;
            }
        }
    });
}

export function getDefaultState(): IDashboardsDirectoryArtifactState {
    return {
        myDashboards: [],
        favorites: [],
        myOwners: [],
        mruDashboard: {} as DashboardWithOwner,
        allDashboards: [],
        allOwners: [],
        canCreateDashboardsPermission: true,
        canManageDashboardsSecurityPermission: true,
        canDeleteDashboardsPermission: true,
        canUseTeamPanelPermission: true
    };
}
